import { rgObjectToDto } from '../../rg-object-to-dto.js';

/** apartments don't store children unless they are templates to save memory */
const apartmentToDto = (apartment, top, skipChildren, versions) => {
    if (skipChildren) {
        return rgObjectToDto({ rgObj: apartment, top, partial: { children: [] }, versions });
    }
    return rgObjectToDto({ rgObj: apartment, top, partial: {}, versions });
};

export { apartmentToDto };
//# sourceMappingURL=apartment-to-dto.js.map
